import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'additions';
export const route = 'additions/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/AdditionsPage')));